import UserGroups from './UserGroups';
import UserGroupsProvider from './UserGroupsContext';

let Index = () => {
    return (
        <UserGroupsProvider>
            <UserGroups />
        </UserGroupsProvider>
    )
}

export default Index;